import SplitButton, { SplitButtonItem } from "designSystem/components/button/SplitButton";
import React from "react";
import CssColumnGrid from "../../CssColumnGrid";

export default () => {
	const buttons: SplitButtonItem[] = [
		{
			text: "Primary",
		},
		{
			text: "Secondary",
		},
		{
			res: "MoreColors",
		},
	];

	return (
		<CssColumnGrid columns={1}>
			<SplitButton buttons={buttons} />
		</CssColumnGrid>
	);
};